// Generated by purs version 0.13.8
"use strict";
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Set = require("../Data.Set/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Dataflow_TypeEnv = require("../Lunarbox.Data.Dataflow.TypeEnv/index.js");
var Substitution = function (x) {
    return x;
};
var Substituable = function (apply, ftv) {
    this.apply = apply;
    this.ftv = ftv;
};
var monoidSubstitution = Data_Map_Internal.monoidMap(Lunarbox_Data_Dataflow_Type.ordTVarName);
var ftv = function (dict) {
    return dict.ftv;
};
var eqSubstitution = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Map_Internal.eqMap(Lunarbox_Data_Dataflow_Type.eqTVarName)(Lunarbox_Data_Dataflow_Type.typeEq))(x)(y);
    };
});
var apply = function (dict) {
    return dict.apply;
};
var arrSubst = function (dictSubstituable) {
    return new Substituable((function () {
        var $40 = Data_Functor.map(Data_List_Types.functorList);
        var $41 = apply(dictSubstituable);
        return function ($42) {
            return $40($41($42));
        };
    })(), Data_Foldable.foldr(Data_List_Types.foldableList)((function () {
        var $43 = Data_Set.union(Lunarbox_Data_Dataflow_Type.ordTVarName);
        var $44 = ftv(dictSubstituable);
        return function ($45) {
            return $43($44($45));
        };
    })())(Data_Set.empty));
};
var typeSubst = new Substituable(function (v) {
    return function (v1) {
        if (v1 instanceof Lunarbox_Data_Dataflow_Type.TConstant) {
            return Lunarbox_Data_Dataflow_Type.TConstant.create(v1.value0)(Data_Functor.map(Data_Functor.functorArray)(apply(typeSubst)(v))(v1.value1));
        };
        if (v1 instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
            return Data_Maybe.fromMaybe(v1)(Data_Map_Internal.lookup(Lunarbox_Data_Dataflow_Type.ordTVarName)(v1.value1)(v));
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Class.Substituable (line 31, column 1 - line 37, column 28): " + [ v.constructor.name, v1.constructor.name ]);
    };
}, function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant) {
        return Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Set.monoidSet(Lunarbox_Data_Dataflow_Type.ordTVarName))(ftv(typeSubst))(v.value1);
    };
    if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
        if (v.value0) {
            return Data_Set.singleton(v.value1);
        };
        if (Data_Boolean.otherwise) {
            return Data_Set.empty;
        };
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Class.Substituable (line 31, column 1 - line 37, column 28): " + [ v.constructor.name ]);
});
var schemeSubst = new Substituable(function (v) {
    return function (v1) {
        var newScheme = Substitution(Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Map_Internal["delete"](Lunarbox_Data_Dataflow_Type.ordTVarName))(v)(v1.value0));
        return Lunarbox_Data_Dataflow_Scheme.Forall.create(v1.value0)(apply(typeSubst)(newScheme)(v1.value1));
    };
}, function (v) {
    return Data_Set.difference(Lunarbox_Data_Dataflow_Type.ordTVarName)(ftv(typeSubst)(v.value1))(Data_Set.fromFoldable(Data_Foldable.foldableArray)(Lunarbox_Data_Dataflow_Type.ordTVarName)(v.value0));
});
var envSusbt = new Substituable(function (s) {
    return function (v) {
        return Lunarbox_Data_Dataflow_TypeEnv.TypeEnv(Data_Functor.mapFlipped(Data_Map_Internal.functorMap)(v)(apply(schemeSubst)(s)));
    };
}, function (v) {
    return ftv(arrSubst(schemeSubst))(Data_Map_Internal.values(v));
});
var semigroupSubstitution = new Data_Semigroup.Semigroup(function (v) {
    return function (v1) {
        var m12 = Data_Functor.map(Data_Map_Internal.functorMap)(apply(typeSubst)(v))(v1);
        return Substitution(Data_Map_Internal.union(Lunarbox_Data_Dataflow_Type.ordTVarName)(m12)(v));
    };
});
module.exports = {
    apply: apply,
    ftv: ftv,
    Substitution: Substitution,
    Substituable: Substituable,
    eqSubstitution: eqSubstitution,
    semigroupSubstitution: semigroupSubstitution,
    monoidSubstitution: monoidSubstitution,
    typeSubst: typeSubst,
    schemeSubst: schemeSubst,
    arrSubst: arrSubst,
    envSusbt: envSusbt
};
